module.exports = __webpack_public_path__ + "media/icons/map-icon-rectangle-active-dcdc3314.svg";